<template>
  <div class="fancybox">
    <div class="image-wrapper">
      <div class="header">
        <div class="play" @click.stop="play" v-show="showplaybutton">
          <icon v-if="!isPlay" :type="'play'" :color="'#ccc'"></icon>
          <icon v-else :type="'pause'" :color="'#ccc'"></icon>
        </div>
        <div class="full" @click.stop="full" v-show="showfullbutton">
          <icon v-if="!isFullScreen" :type="'full'" :color="'#ccc'"></icon>
          <icon v-else :type="'exitfull'" :color="'#ccc'"></icon>
        </div>
        <div class="close" @click.stop="close" v-show="showclosebutton">
          <icon :type="'close'" :color="'#ccc'"></icon>
        </div>
      </div>
      <img ref="images" class="image animated" v-for="item in images" v-if="isShow" :src="item.imageUrl" v-show="item.index===index+1" @click.stop="addIndex">
      <div class="footer">
        <span class="caption" @click.stop="" v-show="showcaption">
          <a v-if="showcaptionurl" :href="images[index].url">{{ images[index].caption }}</a>
          <template v-else>
            {{ images[index].caption }}
          </template>
        </span>
        <span class="count" @click.stop="" v-show="showimagecount">{{ index+1 }} {{imagecountseparator}} {{ images[index].total }}</span>
      </div>
    </div>
    <div v-if="index > 0" class="arrow left" @click.stop="decIndex">
      <icon :type="'arrowLeft'" :color="'#ccc'"></icon>
    </div>
    <div v-if="index < images[index].total-1" class="arrow right" @click.stop="addIndex">
      <icon :type="'arrowRight'" :color="'#ccc'"></icon>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import icon from './common/icon.vue'

  export default {
    props: {
      isShow: Boolean,
      index: Number,
      images: Array,
      reset: Boolean,
      animate: {
        type: Boolean,
        default: false
      },
      showplaybutton: Boolean,
      showfullbutton: Boolean,
      showclosebutton: Boolean,
      showcaption: Boolean,
      showcaptionurl: Boolean,
      imagecountseparator: String,
      showimagecount: Boolean
    },
    data () {
      return {
        next: true,
        animation: false,
        isFullScreen: document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen,
        isPlay: false
      }
    },
    methods: {
      decIndex () {
        this.$refs.images[this.index].classList.add('slideOutRight')
        var that = this
        window.setTimeout(() => {
          that.$emit('decIndex')
          that.next = true
          that.animation = true
        }, 350)
      },
      addIndex () {
        if (this.index < this.images[this.index].total - 1) {
          this.$refs.images[this.index].classList.add('slideOutLeft')
          var that = this
          window.setTimeout(() => {
            that.$emit('addIndex')
            that.next = false
            that.animation = true
          }, 350)
        }
      },
      play () {
        this.next = false
        if (!this.isPlay) {
          this.animation = true
          this.$emit('play')
        } else {
          this.animation = false
          this.$emit('pause')
        }
        this.isPlay = !this.isPlay
      },
      full () {
        function launchFullscreen (element) {
          if (element.requestFullscreen) {
            element.requestFullscreen()
          } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen()
          } else if (element.webkitRequestFullscreen) {
            element.webkitRequestFullscreen()
          } else if (element.msRequestFullscreen) {
            element.msRequestFullscreen()
          }
        }

        function exitFullscreen () {
          if (document.exitFullscreen) {
            document.exitFullscreen()
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen()
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen()
          }
        }

        if (this.isFullScreen) {
          exitFullscreen()
          this.isFullScreen = !this.isFullScreen
        } else {
          launchFullscreen(document.documentElement)
          this.isFullScreen = !this.isFullScreen
        }
      },
      close () {
        this.isPlay = false
        this.$emit('pause')
        this.$emit('close')
        this.animation = false
      }
    },
    watch: {
      index () {
        this.$refs.images[this.index].classList.remove('slideInLeft', 'slideInRight', 'slideOutLeft', 'slideOutRight')
        let action = this.next ? 'slideInLeft' : 'slideInRight'
        if (this.animation || this.animate) {
          this.$refs.images[this.index].classList.add(action)
        }
        this.$nextTick(() => {
          if (!this.isPlay) {
            this.animation = false
          }
        })
      },
      reset () {
        if (this.reset) {
          this.isPlay = false
          this.animation = false
        }
      }
    },
    components: {
      icon
    }
  }
</script>


<style src="./fancybox.styl" lang="stylus" scoped/>


// WEBPACK FOOTER //
// fancybox.vue?64a69a1e